import { render } from "./FlyDataBrandLogoIcon.vue?vue&type=template&id=684de316"
import script from "./FlyDataBrandLogoIcon.vue?vue&type=script&lang=js"
export * from "./FlyDataBrandLogoIcon.vue?vue&type=script&lang=js"

import "./FlyDataBrandLogoIcon.vue?vue&type=style&index=0&id=684de316&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__